import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { FortigateCardComponent } from '@app/features/fortigates/components/fortigate-card/fortigate-card.component';
import { CradlepointCardComponent } from '@app/features/cradlepoints/components/cradlepoint-card/cradlepoint-card.component';
import { MerakiCardComponent } from '@app/features/merakis/components/meraki-card/meraki-card.component';
import { LocationCardComponent } from '@app/features/locations/components/location-card/location-card.component';
import { CircuitCardComponent } from '@app/features/circuit/components/circuit-card/circuit-card.component';
import { DeviceComponent } from '@app/features/device-health/pages/device.component';
import { SmartSafeCardComponent } from '../smartsafe/smartsafe-card/smartsafe-card.component';
import { FiberNidCardComponent } from '../circuit/components/fiber-nid-card/fiber-nid-card.component';
import { HealthNavComponent } from '@app/shared/components/health-nav/health-nav.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        HealthNavComponent,
    ],
    declarations: [
        FortigateCardComponent,
        CradlepointCardComponent,
        MerakiCardComponent,
        LocationCardComponent,
        CircuitCardComponent,
        DeviceComponent,
        SmartSafeCardComponent,
        FiberNidCardComponent
    ],
    providers: [],
    exports: [
        FortigateCardComponent,
        CradlepointCardComponent,
        CircuitCardComponent,
        MerakiCardComponent,
        SmartSafeCardComponent
    ],
    bootstrap: []
})
export class DeviceModule {}
